
export const fadeIn = "animate-[fadeIn_0.3s_ease-in]";
export const slideIn = "animate-[slideIn_0.3s_ease-in]";
export const scaleIn = "animate-[scaleIn_0.2s_ease-in]";

export const cardHover = "transition-all duration-300 hover:shadow-lg hover:scale-[1.02] active:scale-[1]";
export const buttonHover = "transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]";
export const linkHover = "transition-colors duration-200 hover:text-primary";

export const imageHover = "transition-transform duration-500 hover:scale-110";
export const cardTransition = "transition-all duration-300 hover:translate-y-[-2px]";
